var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7029 11.7794C12.3302 10.5901 10.2862 9.83339 8.00025 9.83339C5.71358 9.83339 3.66958 10.5907 2.29758 11.7794L0.517578 15.3381H15.4822L13.7029 11.7794ZM7.99091 8.64139C9.79891 8.64139 11.2649 6.90539 11.2649 4.76405C11.2649 2.62272 9.79891 0.886719 7.99091 0.886719C6.18291 0.886719 4.71758 2.62272 4.71758 4.76405C4.71758 6.90539 6.18291 8.64139 7.99024 8.64139H7.99091Z",
    fill: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.369141)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.ed5a7a570a5811ccf0e590beb9e72669.svg";
export { ForwardRef as ReactComponent };